module.exports = __webpack_public_path__ + "static/media/p19.c436273c.jpeg";